/* @flow */

export type Action =
  | { type: 'FETCH_FOLDERS' }
  | { type: 'FETCH_FOLDERS_SUCCESS', response: Object }
  | { type: 'FETCH_FOLDERS_FAILURE', error: Error }
  | { type: 'SAVE_FOLDER' }
  | { type: 'SAVE_FOLDER_SUCCESS', response: Object }
  | { type: 'UPDATE_FOLDER', folder: BucketFolder }
  | { type: 'UPDATE_FOLDER_SUCCESS', response: Object }
  | { type: 'REMOVE_FOLDER', folder: BucketFolder }
  | { type: 'REMOVE_FOLDER_SUCCESS', folderId: number };

export const fetchFolders = (): Action => ({
  type: 'FETCH_FOLDERS',
});

export const fetchFoldersSuccess = (response: Object): Action => ({
  type: 'FETCH_FOLDERS_SUCCESS',
  response,
});

export const fetchFoldersFailure = (error: Error): Action => ({
  type: 'FETCH_FOLDERS_FAILURE',
  error,
});

export const saveFolder = (name: string): Action => ({
  type: 'SAVE_FOLDER',
  name,
});

export const saveFolderSuccess = (response: Object): Action => ({
  type: 'SAVE_FOLDER_SUCCESS',
  response,
});

export const updateFolder = (folder: BucketFolder): Action => ({
  type: 'UPDATE_FOLDER',
  folder,
});

export const updateFolderSuccess = (response: Object): Action => ({
  type: 'UPDATE_FOLDER_SUCCESS',
  response,
});

export const removeFolder = (folder: BucketFolder): Action => ({
  type: 'REMOVE_FOLDER',
  folder,
});

export const removeFolderSuccess = (folderId: number): Action => ({
  type: 'REMOVE_FOLDER_SUCCESS',
  folderId,
});



// WEBPACK FOOTER //
// ./src/modules/bucket/actions/folders.js